export default {
    common: {
        documentTitle: "岱恩教育-学员端",
        close: "关 闭",
        confirm: '确 定',
        cancel: '取 消',
        cancelApp: '取消',
        changetime: '更改时间',
        login: '登 录',
        submit: "提 交",
        nodata: "小智暂未发现任何数据哦!",
        noTime: "暂无可选时间",
        noSession: "暂无会话记录",
        return: "返 回",
        logout: "退" + '\xa0' + "出",
        giveup: "放 弃",
        iSee: "知道了",
        refreshSuc: "刷新成功",
        clearSuc: "清除成功",
        settingSuc: "设置成功",
        finish: "完 成",
        other: "其他",
        index: "岱恩",
        titleTips: "提 示",
        nothing: "无",
        noDevelop: "暂未开发",
        shareTips: "请点击右上角分享",
        daienEducation: "岱恩教育",
        and: "，",
        ended: "。",
        dollar: "元",
        download: "下 载",
        goConfirm: "去确认",
        noMore: "没有更多了",
        loading: "加载中...",
        bind: '绑定',
        jumpHint: "即将从app跳转AI天天练小程序，是否确认跳转？",
        jumpHint1: "即将从app跳转竞赛小程序，是否确认跳转？",
        newJ: "有新消息自动为您加载",
        jxjcancel: "已取消预约，使用的奖学金已返还至账户中",
        dd: "等",
        Reelection: "重 选",
        copy: "复 制",
        copied: "复制成功",
        copyFailed: "复制失败"
    },
    queryOralUser: {
        title: "请输入昵称/手机号/姓名",
        cx: "查询",
        project: "请输入项目名称",
        teacher: "请输入姓名/昵称/地区",
        examPublish: '请输入考试名称'
    },
    daiEnStudent: {
        title: "请输入昵称/姓名/手机号",
    }
}


// WEBPACK FOOTER //
// ./src/lang/zh.js